import React, { useState, useEffect, Fragment } from "react";
import { TransactionStatus } from "../../Contexts/ChainbridgeContext";
import { ReactJSXElement } from "@emotion/react/types/jsx-namespace";
import { Tag, Box, Flex } from "@chakra-ui/react";
import { CheckIcon, CloseIcon } from "@chakra-ui/icons";

interface IStepProgress {
  states: Array<TransactionStatus>;
  currentState: TransactionStatus;
}

type StepDisplayType = string | ReactJSXElement;

const StepProgress: React.FC<IStepProgress> = ({
  states,
  currentState,
}: IStepProgress) => {
  const [lastStateSeen, setLastStateSeen] = useState<TransactionStatus>(
    states[0]
  );
  const iconSize = "12px";

  useEffect(() => {
    if (states.indexOf(currentState) >= 0) {
      setLastStateSeen(currentState);
    }
  }, [currentState]);

  return (
    <Flex justifyContent="space-between">
      {states.map((state) => {
        let stateIndex = states.indexOf(state);
        let currentStateIndex = states.indexOf(currentState);

        // If the current state doesn't match any of the listed states
        // we're in an error case.
        let didError = currentStateIndex < 0;

        // If we did error, rewrite the current state index to make things easier.
        currentStateIndex = didError
          ? states.indexOf(lastStateSeen)
          : currentStateIndex;

        let currentIsAtLastState = currentStateIndex == states.length - 1;

        let stateValue: StepDisplayType = (
          states.indexOf(state) + 1
        ).toString();

        // For all states we've completed, show a check
        if (stateIndex < currentStateIndex) {
          stateValue = <CheckIcon w={iconSize} h={iconSize} />;
        }

        // If we're at the current state, if we errored show an error.
        // If the current state is the last one, show a check.
        if (stateIndex == currentStateIndex) {
          if (didError) {
            stateValue = <CloseIcon width="auto" height="auto" />;
          } else if (currentIsAtLastState) {
            stateValue = <CheckIcon width="auto" height="auto" />;
          }
        }

        let backgroundColor =
          stateIndex <= currentStateIndex ? "brand.800" : "brand.500";

        return (
          <Fragment key={"tag" + stateIndex}>
            <Tag
              fontSize="12px"
              borderRadius="50%"
              variant="solid"
              backgroundColor={backgroundColor}
              color="white"
            >
              {stateValue}
            </Tag>
            <Box
              height="1px"
              width="100%"
              display="block"
              mt="11px"
              backgroundColor={backgroundColor}
            ></Box>
          </Fragment>
        );
      })}
    </Flex>
  );
};

export default StepProgress;
